import { c as _c } from "react/compiler-runtime";
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import PlaybookLinkButton from '../playbook-linkbutton';
type CreatePlaybookProps = {
  detail: AuditEventDetail;
  hasPrincipalActor: boolean;
};
const CreatePlaybook = t0 => {
  const $ = _c(11);
  const {
    detail,
    hasPrincipalActor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.playbooks"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (detail.kind !== "create_playbook") {
    return null;
  }
  const {
    playbook
  } = detail.data;
  let t2;
  if ($[1] !== hasPrincipalActor || $[2] !== t) {
    t2 = hasPrincipalActor ? t(_temp) : capitalize(t(_temp2));
    $[1] = hasPrincipalActor;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="text-body-2 text-tertiary">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== playbook) {
    t4 = <PlaybookLinkButton playbook={playbook} />;
    $[6] = playbook;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default CreatePlaybook;
function _temp($) {
  return $.createdANew;
}
function _temp2($_0) {
  return $_0.createdANew;
}